export function appendDestinationTemplateToOurSide(id) {
	let fromtext = 'From';
	let totext = 'To';

	fromtext = $('#moreDestinations').closest('.formRow').find('.departureFrom').attr("placeholder");

	totext = $('#moreDestinations').closest('.formRow').find('.departureTo').attr("placeholder");



	return `
  <div class="row  new-destination-row mt-md-2 mt-3 position-relative flex-wrap-reverse">
	<div class="order-1 col-12 col-lg-3 mb-md-0 mb-1 focusControl">
		<div class="align-items-center row mx-0">
	
			<input
			type="search"
			name="departureFrom-${id}"
			id="DepartureFrom-${id}"
		    class = "form-control  airportInput "
			placeholder = "${fromtext}"
			data-emo-custom="needed"
			/>
		
			<div class="messages"></div>
		
		</div>
	</div>
  <div class = "order-2 col-12 col-lg-3 mb-md-0 mb-1 focusControl" >
	 <div class="align-items-center row mx-0">
		
		<input
		   type="search"
		   name="departureTo-${id}"
		   id="DepartureTo-${id}"
		   class = "form-control  airportInput "
		   placeholder = "${totext}"
		   data-emo-custom="needed"
		   />
		
		<div class="messages"></div>
	 </div>
  </div>
  <div class = "order-3 col-12 col-lg-3 mb-md-0 mb-1   ">

	 <input
	 type="text"
	 class= "form-control datePicker datePicker-${id}"
	 placeholder="Departure Date"
	 name="date-${id}"
	 data-emo-custom="needed"
	 autocomplete="off"
	 />
  </div>
  <div class = "align-items-center col-1 d-flex deleteRow deleteNRow h-100 justify-content-center" >
	<svg width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M512 60.333L451.667 0L255.999 195.666L60.333 0L0 60.333L195.666 255.999L0 451.667L60.333 512L255.999 316.334L451.666 512L511.999 451.667L316.334 255.999L512 60.333Z" fill="black"/>
	</svg>
  </div>
</div>
  `
}

export default appendDestinationTemplateToOurSide
